<!--Link-->
<ng-container *ngIf="!link?.listLink">
  <a *ngIf="!link?.disabled" [routerLink]="[link?.router]" [routerLinkActive]="'active'"
    (click)="handleClickRoute(link?.router, true)" class="button-sidenav" [ngClass]="{
      'router-link-primary': link?.type === 'primary',
      'router-link': link?.type !== 'primary'
     }" >
    <div matRipple [ngClass]="{
          'sidenav-menu': myCollapse,
          'sidenav-menu-collapse': !myCollapse,
          'sub-menu': subMenu
         }" title="{{link?.name}}">
         <icon-induxtry [icon]="{ icon: link?.icon, width: 28, height: 28}"></icon-induxtry>
      <!-- <mat-icon routerLinkActive="active-link" *ngIf="link?.icon" [class.teste]="!myCollapse"
        class="material-icons-outlined" svgIcon="{{link?.icon}}"></mat-icon> -->

      <span *ngIf="child || myCollapse" class="menu-title"
        [ngClass]="{'menu-title-tertiary': link?.type === 'tertiary' && !myCollapse, 'menu-title': !(link?.type === 'tertiary' && !myCollapse)}"
        [ngStyle]="{
             'padding-left':  link?.type === 'tertiary' && myCollapse ? '32px' :
             link?.type === 'quaternary' && myCollapse ? '44px' :
             link?.type === 'quaternary' && !myCollapse ? '10px' :
             null,
             'font-size': link?.type === 'quaternary' && !myCollapse ? '12px' : null
             }">{{link?.name}}</span>
    </div>
  </a>
  <!--Disabled-->
  <div *ngIf="link?.disabled" class="router-disable">
    <div matRipple [ngClass]="{
          'sidenav-menu': myCollapse,
          'sidenav-menu-collapse': !myCollapse,
          'sidenav-menu-collapse-primary': !myCollapse && link?.type === 'primary',
          'sub-menu': subMenu
         }" title="{{link?.name}}" [ngStyle]="{'margin': link?.type === 'primary' && myCollapse ? '2px 7px': null}">
      <mat-icon routerLinkActive="active-link" *ngIf="!child" [class.teste]="!myCollapse"
        class="material-icons-outlined" svgIcon="{{link?.icon}}"></mat-icon>

      <span *ngIf="child || myCollapse" class="menu-title"
        [ngStyle]="{'left.px': link?.type === 'tertiary' ? 35 : null}">{{link?.name}}</span>
    </div>
  </div>
</ng-container>

<!--Menu-->
<mat-expansion-panel dense hideToggle title="{{link?.name}}" *ngIf="link?.listLink && myCollapse"
  [class.mat-elevation-z0]="true" [ngClass]="{
                      'primary-active': activeRoute(link?.router) && link?.type !== 'secondary',
                      'secondary-active': activeRoute(link?.router) && link?.type === 'secondary',
                      'secondary-not-active': !activeRoute(link?.router) && link?.type === 'secondary',
                      'tertiary-active': activeRoute(link?.router, link) && link?.type === 'tertiary',
                      'tertiary-not-active': !activeRoute(link?.router, link) && link?.type === 'tertiary',
                      'disabled' : link?.disabled
                      }" [disabled]="link?.disabled" (opened)="panelOpenState = true"
  (closed)="panelOpenState = false">
  <mat-expansion-panel-header matRipple style="height: 46px;" [collapsedHeight]="'44px'" [expandedHeight]="'44px'">
    <mat-panel-title style="height: 40px; border-radius: 4px; display: flex;">
      <div class="box" style="display: flex;justify-content: flex-start; width: 90%; align-items: center;">
        <mat-icon *ngIf="link?.icon" [ngClass]="{'active-link': activeRoute(link?.router), 'tx': !myCollapse}"
          class="material-icons-outlined" svgIcon="{{link?.icon}}"></mat-icon>
        <span *ngIf="myCollapse" style="margin-left: 16px;">{{link?.name}}</span>
      </div>
      <mat-icon class="icon-status-panel"
        style="width: 10%;font-size: 16px; position: relative;align-self: center;">{{panelOpenState? 'keyboard_arrow_up'
        : 'keyboard_arrow_down'}}</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!--Sub Menu-->
  <div *ngIf="myCollapse">
    <ng-container *ngFor="let info of link?.listLink">
      <app-sidenav-menu [link]="info" [child]="true" [subMenu]="true" [collapse]="myCollapse"
        (linkClose)="handleClick($event)">
      </app-sidenav-menu>
    </ng-container>
  </div>
</mat-expansion-panel>

<!-- <mat-expansion-panel  dense
                      hideToggle
                      title="{{link?.name}}"
                      *ngIf="link?.listLink && !myCollapse"
                      [class.mat-elevation-z0]="true"
                      [ngClass]="{
                        'primary-active': activeRoute(link?.router) && link?.type !== 'secondary',
                        'secondary-active': activeRoute(link?.router) && link?.type === 'secondary',
                        'tertiary-active': !activeRoute(link?.router) && link?.type === 'secondary',
                        'disabled' : link?.disabled
                        }"
                      [matMenuTriggerFor]="link?.disabled? undefined: menu"
                      [disabled]="link?.disabled"
                      (click)="preventMenuClose($event,link?.type)"
                      [matTooltip]="!myCollapse? link?.name: null"
                      >
  <mat-expansion-panel-header matRipple style="height: 40px;"
                              [collapsedHeight]="'44px'"
                              [expandedHeight]="'44px'">
    <mat-panel-title style="height: 40px; border-radius: 4px; display: flex;">
      <div style="display: flex; width: 80%;">
        <mat-icon [ngClass]="{'active-link': activeRoute(link?.router), 'tx': !myCollapse}" *ngIf="link?.icon" class="material-icons-outlined" svgIcon="{{link?.icon}}"></mat-icon>
        <span *ngIf="myCollapse || (!myCollapse && link?.type === 'secondary') " style="margin-left: 12px;">{{link?.name}}</span>
      </div>
      <mat-icon class="icon-status-panel" style="width: 20%; font-size: 16px; position: relative;">keyboard_arrow_right</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>

</mat-expansion-panel> -->

<!--[matMenuTriggerFor]="link?.disabled? undefined: menu"-->
<button *ngIf="link?.listLink && !myCollapse" class="container-collapse" [matMenuTriggerFor]="menu"
  [disabled]="link?.disabled" (click)="preventMenuClose($event,link?.type)" [ngClass]="{
  'container-collapse-primary': activeRoute(link?.router) && link?.type !== 'secondary',
  'container-collapse-secondary': activeRoute(link?.router) && link?.type === 'secondary',
  'container-collapse-not-secondary': !activeRoute(link?.router) && link?.type === 'secondary',
  'container-collapse-tertiary': activeRoute(link?.router) && link?.type === 'tertiary',
  'container-collapse-not-tertiary': !activeRoute(link?.router) && link?.type === 'tertiary',
  'container-collapse-disabled' : link?.disabled
  }" [ngStyle]="link?.type === 'secondary' || link?.type === 'tertiary'? {'width':'97%', 'padding':'0 14px'} : null"
  [matTooltip]="link?.name" matTooltipClass="induxtry-tooltip">
  <div class="container-nav">
    <div class="content">
      <mat-icon [ngClass]="{'active-link': activeRoute(link?.router), 'tx': !myCollapse}" *ngIf="link?.icon"
        class="material-icons-outlined" svgIcon="{{link?.icon}}"></mat-icon>
      <span
        *ngIf="myCollapse || (!myCollapse && link?.type === 'secondary') || (!myCollapse && link?.type === 'tertiary') "
        [ngStyle]="link?.type === 'secondary' && !link?.listLink ? { 'margin-left': '12px' } : { 'margin-left': '0px' }">{{link?.name}}</span>
    </div>
    <mat-icon class="icon-status-panel">keyboard_arrow_right</mat-icon>
  </div>
</button>


<mat-menu [class]="link?.type !== 'primary'? 'menu-sidenav' : 'menu-sidenav-tertiary'" #menu="matMenu"
  [hasBackdrop]="true">
  <app-sidenav-menu *ngFor="let info of link?.listLink" [link]="info" [child]="true" [subMenu]="true"
    [collapse]="myCollapse" (linkClose)="handleClick($event)">
  </app-sidenav-menu>
</mat-menu>